import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  FieldRadioPanelWrapper
} from './styled'

export class FieldRadioPanel extends React.PureComponent {
  render () {
    const {
      className,
      id,
      name,
      value,
      isChecked,
      onChange,
      label,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'field-radio-panel',
      className
    )

    return (
      <FieldRadioPanelWrapper
        className={classes}
      >
        <input className='field-radio-panel-value'
          type='radio'
          id={id}
          name={name}
          value={value}
          checked={isChecked}
          onChange={onChange}
        />
        <label className='field-radio-panel-label'
          htmlFor={id}
        >
          <div className="field-radio-panel-box"></div>
          <div className="field-radio-panel-label-text">
            {label}
          </div>
        </label>
      </FieldRadioPanelWrapper>
    )
  }

  static defaultProps = {
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}
